'use es6';

import { Image } from 'foundations-components/transitional/components/Image';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const IconListItem = ({
  iconUrl,
  title
}) => {
  return /*#__PURE__*/_jsx(MediaObject, {
    align: "start",
    itemLeft: /*#__PURE__*/_jsx(Image, {
      marginBlockStart: "50",
      blockSize: "20px",
      minInlineSize: "20px",
      src: iconUrl
    }),
    marginBlockEnd: "200",
    children: title
  });
};
IconListItem.propTypes = {
  iconUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
export default IconListItem;